document.addEventListener("DOMContentLoaded", function () {
  let cartlist = document.querySelector(".shoplist");
  let popUpComponent = document.querySelector("#cart-message");

  function openPopUpComponent() {
    popUpComponent.classList.toggle("is-open");
  }

  function closePopUpComponent() {
    popUpComponent.classList.remove("is-open");
  }

  // MutationObserver para detectar cuando aparece .shoplist
  if (!cartlist) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Verificar si el nodo añadido es nuestro carrito
              if (node.classList && node.classList.contains('shoplist')) {
                cartlist = node;
                setupCartListeners();
                observer.disconnect();
                return;
              }
              
              // Verificar si contiene nuestro carrito
              const foundCart = node.querySelector && node.querySelector('.shoplist');
              if (foundCart) {
                cartlist = foundCart;
                setupCartListeners();
                observer.disconnect();
                return;
              }
            }
          });
        }
      });
    });
    
    observer.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function isElementValid(element, elementName) {
    if (!element) {
      console.warn(`${elementName} no está disponible`);
      return false;
    }
    return true;
  }
  
  // Funciones para el carrito
  function open() {
    try {
      if (!isElementValid(cartlist, 'Cart List')) return false;
      
      cartlist.classList.toggle("open-cart-list");
      document.body.classList.add('no-scroll');
      
      if (overlay) {
        overlay.classList.add('show');
      }
      
      return true;
    } catch (error) {
      console.error('Error al abrir carrito:', error);
      return false;
    }
  }
  
  function close() {
    try {
      if (!isElementValid(cartlist, 'Cart List')) return false;
      
      cartlist.classList.remove("open-cart-list");
      document.body.classList.remove('no-scroll');
      
      if (overlay) {
        overlay.classList.remove('show');
      }
      
      return true;
    } catch (error) {
      console.error('Error al cerrar carrito:', error);
      return false;
    }
  }

  try {
    document.getElementById('overlay').addEventListener( 'click', function() {
      close(); 
    });
  } catch (error) {
    console.log(error);
  }

  const productHTML = (
    product_id,
    product_image,
    product_link,
    product_name,
    product_qty,
    product_price
  ) => `
<div class="product product-${product_id}">
    <div class="product-image-space">
        <img class="product-image" loading="lazy" src="${product_image}" alt="Imagen de Producto">
    </div>

    <div class="product-description">
        <input name="id" id="product-item-cart-${product_id}" value="${product_id}" type="hidden" />
        <div>
          <a class="product-description-name" href="${product_link}">${product_name}</a>
        </div>
        <div class="product-description-info">
            
            <div class="product-description-all">
                <div class="product-description-qty">
                    <button type="button" id="remove-product-${product_id}" class="remove" data-product-id="${product_id}">-</button>
                    <input type="number" name="updates[]" min="1" step="1" value="${product_qty}" class="input-qty" id="input-qty-${product_id}" />
                    <button type="button" id="add-product-${product_id}" class="add" data-product-id="${product_id}">+</button>
                </div>
                <div class="loading-container" id="loading-container-${product_id}">
                    <div class="loading-bar">
                        <div class="inner-bar"></div>
                    </div>
                </div>
                <span class="product-price-cart" id="product-price-${product_id}">$ ${product_price}</span>
                <button class="erase-product" type="button" data-product-id="${product_id}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash-2">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                        <path d="M1 6h22"></path>
                        <path d="M4 6l1-4h14l1 4"></path>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
`;

  const recommendedProduct = (
    product_id,
    product_image,
    product_link,
    product_name,
    product_price,
    compare_at_price
  ) => ` 
        <div class="new_recommended_product" id="product-${product_id}-recomended">
            <div class="">
                <input id="product-recommended-${product_id}" name="id" value="${product_id}" type="hidden" />
                <h3>
                    <a class="product-description-name recomended-text" id="product-name-${product_id}-recomended" href="${product_link}">
                        ${product_name}
                    </a>
                </h3>
            </div>
        
            <div class="">
                <img class="product-image" id="product-image-${product_id}-recomended" loading="lazy" src="${product_image}" alt="Imagen de Producto">
            </div>
        
            <div class="footer__product">
                <div>
                    <span id="product-price-${product_id}-recomended">
                        <span class="compare-price-money">$ ${product_price}</span>
                        <br>
                        ${compare_at_price > 0 ? `<del class="price_to_compare">$ ${compare_at_price}</del>` : ''}
                    </span>
                </div>
                <div>
                    <input type="hidden" name="quantity" value="1" class="input-qty" id="input-qty-${product_id}-recomended"/>
                    <button type="button" data-product-id="${product_id}" class="add-product add-product-recommeded">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 68 64"><path d="M2.24 0.576c3.52-0.704 7.168 0.192 10.24 1.792 2.624 1.344 4.224 4.096 5.056 6.848 0.96 3.008 1.344 6.144 1.92 9.216 0.96 5.056 2.304 10.048 3.072 15.104 0.384 2.048 0.704 4.224 2.112 5.888 1.408 1.6 3.776 1.664 5.824 1.728 5.376 0 10.816-0.256 16.192 0.128 1.344 0.064 2.88 0 3.648-1.344 3.52-5.312 6.464-11.008 9.28-16.768 0.576-1.152 1.28-2.368 2.56-2.816 1.344-0.448 3.008-0.256 4.032 0.768 1.152 1.28 1.344 3.2 0.704 4.736-2.688 5.376-5.184 10.816-8.512 15.872-1.472 2.176-3.008 4.544-5.184 6.144-1.792 1.28-4.096 0.832-6.144 0.768-6.272-0.064-12.544 0.384-18.752 0-4.16-0.32-8.256-2.368-10.624-5.888-1.728-2.752-2.368-6.080-3.008-9.216-1.28-6.784-2.624-13.504-3.904-20.288-0.384-1.6-0.896-3.392-2.304-4.352-2.24-1.6-5.376-0.256-7.552-1.984-1.344-0.96-0.704-2.688-0.832-4.096-0.128-1.216 1.152-1.984 2.176-2.24zM34.432 4.928c-0.064-1.216 1.408-1.536 2.368-1.792 2.048-0.32 4.608-0.384 6.208 1.152 0.448 3.776 0.64 7.616 0.768 11.392 1.92 0.128 3.84-0.256 5.76-0.064 0.704 0.064 1.536 0.512 1.472 1.344-0.32 1.472-1.472 2.56-2.368 3.712-2.688 3.456-5.76 6.528-8.832 9.536-0.448 0.448-1.024 0.704-1.6 0.448-1.216-0.512-1.984-1.728-2.88-2.688-2.112-2.304-4.224-4.544-6.144-6.912-0.96-1.216-2.176-2.24-2.624-3.712-0.256-0.832 0.512-1.6 1.344-1.664 1.92-0.256 3.84 0.128 5.76 0 0.256-3.584 0.384-7.168 0.768-10.752zM25.28 51.584c2.432-0.704 5.184 0 6.784 1.856 2.368 2.624 1.984 7.232-0.96 9.216-3.136 2.304-8.448 1.216-9.92-2.56-1.664-3.328 0.64-7.616 4.096-8.512zM45.376 53.504c2.432-2.88 7.36-2.944 9.856-0.128 2.112 2.304 2.048 6.208-0.064 8.512-1.216 1.28-2.944 2.048-4.672 2.112h-0.128c-1.856-0.064-3.776-0.832-4.928-2.24-2.048-2.304-2.112-6.016-0.064-8.256z"></path></svg>
                    </button>
                </div>
            </div>
        </div>`;

  async function getAllCartData() {
    const response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.json();
  }

  function updateAllCart() {
    
    getAllCartData()
      .then((data) => {
        const items = data.items;
        const total_money = document.querySelector(`.total-money`);
        total_money.innerHTML = `$ ${(data.total_price / 100).toFixed(2)}`;

        /* Min to free shipping */

        let difference = (4500 - (data.total_price / 100));
        let percentageDifference = 100 - ((difference / 4500) * 100);

        
        if (difference >= 0) {
          const progress_bar = document.querySelector('.progress-bar');
          progress_bar.style.width = `${percentageDifference.toFixed(0)}%`;
          const money_difference = document.getElementById('timer-message');
          money_difference.innerHTML = `¡SOLO FALTAN $${difference} PARA ENVÍO GRATIS!`;
        } else {
          const progress_bar = document.querySelector('.progress-bar');
          progress_bar.style.width = `100%`;
          const money_difference = document.getElementById('timer-message');
          money_difference.innerHTML = "¡Felicidades! Tienes envío gratis";
        }

        
        const count = document.getElementById('cart-item-count-bubble');
        const total = document.getElementById('cart-total-price-bubble');
        if (count) {
          count.innerHTML = data.item_count;
        }

        if (total) {
          total.innerHTML = `<span class="money">$ ${data.total_price/100} </span>`;
        }
        

        if (data.item_count == 0) {
          var section = document.querySelector(".product-list")
          var div = document.createElement("div");
          div.className = "text";
          div.textContent = "El carrito esta vacio";
          section.innerHTML = "";
          section.appendChild(div);
        } else {
          const product_list = document.querySelector(`.product-list`);
          product_list.innerHTML = "";

          items.forEach((item) => {
            console.log(item);
            const product_id = item.id;
            const product_image = item.image;
            const product_link = item.url;
            const product_name = item.title;
            const product_qty = item.quantity;
            const product_price = item.price;

            product_list.innerHTML += productHTML(
              product_id,
              product_image,
              product_link,
              product_name,
              product_qty,
              product_price / 100,
              
            );
          });

          updateListeners();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  async function getProductRecommendations(id) {
    const response = await fetch(
      window.Shopify.routes.root +
        `recommendations/products.json?product_id=${id}`
    );

    return response.json();
  }

  function getAllRecomendations() {
  
    getAllCartData()
    .then((data) => {

      const recommendationsContainerOne = document.getElementById('dinamically-1');

      recommendationsContainerOne.innerHTML = "";

      if (data.item_count > 0){
          const products = data.items;
          
          
          products.forEach( (product) => {
              getProductRecommendations(product.product_id)
              .then( (relatedProducts) => {
                  console.log(relatedProducts);
                  const recommendation = relatedProducts.products;
                  let AllRecomendations = [];
                  
                  recommendation.forEach( (item) => {
                      if (item.variants[0].available) {
                          AllRecomendations.push(item);
                      }
                  });


                  for (let i = 0; i < AllRecomendations.length; i++) {

                      const product = AllRecomendations[i];

                      let id = 0;
                      let title = "";
                      let price = 0;
                      let url = "";
                      let image = "";
                      let compare_price = 0;

                      id = product.variants[0].id;
                      title = product.title;
                      price = product.price / 100;
                      url = product.url;
                      image = product.featured_image;
                      compare_price = product.variants[0].compare_at_price / 100;

                      recommendationsContainerOne.innerHTML += recommendedProduct(
                          id,
                          image,
                          url,
                          title,
                          price,
                          compare_price
                      );

                      const recommendations = recommendationsContainerOne.children;

                      // Iteramos sobre los elementos del contenedor
                      for (let i = 0; i < recommendations.length; i++) {
                        if (i < 3) {
                          // Mostramos los primeros tres elementos
                          recommendations[i].style.display = "flex";
                        } else {
                          // Ocultamos los demás elementos
                          recommendations[i].style.display = "none";
                        }
                      }
                  }

                  updateListenersRecommended();
              })
              .catch( (error) => {
                  console.error(error);
              });
          });

      } else if(data.item_count == 0) {
          
          getProductRecommendations(4609298104395)
          .then( (relatedProducts) => {
              const recommendation = relatedProducts.products;
              let AllRecomendations = [];
              
              recommendation.forEach( (item) => {
                  if (item.variants[0].available) {
                      AllRecomendations.push(item);
                  }
              });


              for (let i = 0; i < AllRecomendations.length; i++) {

                  const product = AllRecomendations[i];

                  let id = 0;
                  let title = "";
                  let price = 0;
                  let url = "";
                  let image = "";
                  let compare_price = 0;

                  id = product.variants[0].id;
                  title = product.title;
                  price = product.price / 100;
                  url = product.url;
                  image = product.featured_image;
                  compare_price = product.variants[0].compare_at_price / 100;

                  recommendationsContainerOne.innerHTML += recommendedProduct(
                      id,
                      image,
                      url,
                      title,
                      price,
                      compare_price
                  );

                  const recommendations = recommendationsContainerOne.children;

                  // Iteramos sobre los elementos del contenedor
                  for (let i = 0; i < recommendations.length; i++) {
                    if (i < 3) {
                      // Mostramos los primeros tres elementos
                      recommendations[i].style.display = "flex";
                    } else {
                      // Ocultamos los demás elementos
                      recommendations[i].style.display = "none";
                    }
                  }
              }

              updateListenersRecommended();
          })
          .catch((error) => {
              console.error(error);
          });

      }

    })
    .catch((error) => {
      console.error(error);
    });
      
  }

  async function deleteCartElement(id) {
    let updates = {
      id: id,
      quantity: 0,
    };

    const response = await fetch(
      window.Shopify.routes.root + "cart/change.js",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updates),
      }
    );

    updateAllCart();
    getAllRecomendations();

    return response.json();
  }

  async function addCartElement(id) {
    const qty = document.getElementById(`input-qty-${id}-recomended`);
    
   
    const formData = {
      items: [
        {
          id: id,
          quantity: parseInt(qty.value),
        },
      ],
    };

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    updateAllCart();
    getAllRecomendations();

    return response.json();
  }

  async function addCartElementOne(id) {

    const formData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
    };

    const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    updateAllCart();
    getAllRecomendations();

    return response.json();
  }

  function updateCart(id) {
    const qtyInput = document.getElementById(`input-qty-${id}`);

    let updates = {
      id: id,
      quantity: parseInt(qtyInput.value),
    };

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [id]: updates.quantity,
        },
      }),
    })
      .then((response) => {
        updateAllCart();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  function initSlider(slider, index) {

    const buttonNext = slider.querySelector('.next-recomended');
    const buttonBack = slider.querySelector('.back-recomended');
    const sliderBox = slider.querySelector('.recommended-products-container');
    const slides = sliderBox.children;

    let currentIndex = 1;

    buttonNext.addEventListener( 'click', function () {
      plusSlides(1);
    });

    buttonBack.addEventListener('click', function() {
      plusSlides(-1);
    });

    function plusSlides(n) {
      showSlides((currentIndex += n))
    }

    function showSlides(n) {
     
      if (n > slides.length) {
        currentIndex = 1;
      }
      if (n < 1) {
        currentIndex = slides.length;
      }
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
  
      slides[currentIndex - 1].style.display = "flex";
      slides[currentIndex].style.display = "flex";
      slides[currentIndex + 1].style.display = "flex";
      
      
    }
  }

  Array.from(document.getElementsByClassName('slider-cart')).forEach( (slider, index) => {
    initSlider(slider, index);
  });

  /* Listeners for line items in cart */
  function updateListeners() {

    Array.from(document.getElementsByClassName("add")).forEach((button) => {
      const product_id = button.getAttribute("data-product-id");
      button.addEventListener("click", function () {
        const tag = document.getElementById(`input-qty-${product_id}`);
        tag.value = parseInt(tag.value) + 1;
        updateCart(product_id);

        const loadingbar = document.getElementById(
          `loading-container-${product_id}`
        );

        loadingbar.style.display = "flex";

        setTimeout(() => {
          loadingbar.style.display = "none";
        }, "500");
      });
    });

    Array.from(document.getElementsByClassName("remove")).forEach((button) => {
      const product_id = button.getAttribute("data-product-id");
      button.addEventListener("click", function () {
        const tag = document.getElementById(`input-qty-${product_id}`);
        if (tag.value >= 1) {
          tag.value = parseInt(tag.value) - 1;
          updateCart(product_id);

          const loadingbar = document.getElementById(
            `loading-container-${product_id}`
          );

          loadingbar.style.display = "flex";

          setTimeout(() => {
            loadingbar.style.display = "none";
          }, "500");
        }
      });
    });

    Array.from(document.getElementsByClassName("erase-product")).forEach(
      (button) => {
        const product_id = button.getAttribute("data-product-id");

        const product_to_erase = document.querySelector(
          `.product-${product_id}`
        );

        button.addEventListener("click", function () {
          deleteCartElement(product_id).then((data) => {
            if (product_to_erase) {
              product_to_erase.remove();
            }

            setTimeout(() => {
              updateAllCart();
            }, "1000");
          });
        });
      }
    );

  }

  function updateListenersRecommended(){
    /* Listeners for Recomended Products */

    Array.from(document.getElementsByClassName("add-recomended")).forEach((button) => {
        const product_id = button.getAttribute("data-product-id");
        button.addEventListener("click", function () {
          const tag = document.getElementById(
            `input-qty-${product_id}-recomended`
          );
          tag.value = parseInt(tag.value) + 1;
        });
      }
    );

    Array.from(document.getElementsByClassName("remove-recomended")).forEach((button) => {
        const product_id = button.getAttribute("data-product-id");
        button.addEventListener("click", function () {
          const tag = document.getElementById(
            `input-qty-${product_id}-recomended`
          );
          if (tag.value >= 1) {
            tag.value = parseInt(tag.value) - 1;
          }
        });
      }
    );

    Array.from(document.getElementsByClassName("add-product-recommeded")).forEach((button) => {
      const product_id = button.getAttribute("data-product-id");

      button.addEventListener("click", function () {
        addCartElement(product_id).then((data) => {
          updateAllCart();
        });
      });
    });
  }


 // document.getElementById('default-cart-recomended').firstElementChild.style.display = "flex";


  // ========== Collection ============

  Array.from(document.getElementsByClassName("add-recomended-collection")).forEach((button) => {
    const product_id = button.getAttribute("data-product-id");
    button.addEventListener("click", function () {
      const tag = document.getElementById(
        `input-qty-${product_id}-recomended`
      );
      tag.value = parseInt(tag.value) + 1;
    });
  }
);

Array.from(document.getElementsByClassName("remove-recomended-collection")).forEach((button) => {
    const product_id = button.getAttribute("data-product-id");
    button.addEventListener("click", function () {
      const tag = document.getElementById(
        `input-qty-${product_id}-recomended`
      );
      if (tag.value >= 1) {
        tag.value = parseInt(tag.value) - 1;
      }
    });
  }
);

Array.from(document.getElementsByClassName("add-product-recommeded-colletion")).forEach((button) => {
  const product_id = button.getAttribute("data-product-id");

  button.addEventListener("click", function () {
    addCartElement(product_id).then((data) => {
      updateAllCart();
    });
  });
});


  // updateAllCart();
  // getAllRecomendations();

  console.log('cart-loaded');

  try {

    document
    .getElementById("add-product-one-banner")
    .addEventListener("click", function () {
      addCartElementOne(48755820200226)
        .then(() => {
          open();
          setTimeout(() => {
            updateAllCart();
            getAllRecommendations();
          }, 1000);
        });
    });

    
  } catch (error) {
    console.log(error);
  }

  try {

    document
    .getElementById("add-product-two-banner")
    .addEventListener("click", function () {
      addCartElementOne(48755821019426)
        .then(() => {
          open();
          setTimeout(() => {
            updateAllCart();
            getAllRecommendations();
          }, 1000);
        });
    });

    
  } catch (error) {
    console.log(error);
  }

  try {
    document
      //.getElementById("open-when-add")
      //.addEventListener("click", function () {
        //open();
        //setTimeout(() => {
          //updateAllCart();
          //getAllRecomendations();
        //}, "1000");
      //});

    .getElementById("open-when-add")
    .addEventListener("click", function() {
      openPopUpComponent();
    });
    
  } catch (error) {
    console.log(error);
  }

  try {
    document
      .querySelector(".btn-close")
      .addEventListener( "click", function(){
        closePopUpComponent();
      });
    
  } catch (error) {
    console.log(error);
  }

  // Reemplaza tu función initializeCartListenerWithObserver() actual con esta versión corregida:

  function initializeCartListenerWithObserver() {
    const cartIcon = document.getElementById("cart-icon-bubble");
    
    if (cartIcon) {
      // El elemento ya existe, verificar si ya tiene el listener
      if (!cartIcon.hasAttribute('data-cart-listener')) {
        cartIcon.addEventListener("click", function() {
          console.log("Cart icon clicked!"); // Debug
          updateAllCart();
          getAllRecomendations();
          open();
        });
        cartIcon.setAttribute('data-cart-listener', 'true');
        console.log("Event listener agregado exitosamente al cart-icon-bubble");
      }
      return;
    }
    
    // Usar MutationObserver para detectar cuando se agrega el elemento
    const observer = new MutationObserver((mutations, obs) => {
      const cartIcon = document.getElementById("cart-icon-bubble");
      if (cartIcon && !cartIcon.hasAttribute('data-cart-listener')) {
        cartIcon.addEventListener("click", function() {
          console.log("Cart icon clicked!"); // Debug
          updateAllCart();
          getAllRecomendations();
          open();
        });
        cartIcon.setAttribute('data-cart-listener', 'true');
        console.log("Event listener agregado exitosamente al cart-icon-bubble");
        obs.disconnect(); // Dejar de observar
      }
    });
    
    // Observar cambios en el DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Timeout de 10 segundos
    setTimeout(() => {
      observer.disconnect();
      const cartIcon = document.getElementById("cart-icon-bubble");
      if (!cartIcon) {
        console.error("Timeout: Elemento cart-icon-bubble no encontrado después de 10 segundos");
      }
    }, 10000);

  }
  
  // Alternativa más robusta usando event delegation:
  function initializeCartListenerWithDelegation() {
    // Remover cualquier listener previo
    document.removeEventListener('click', handleCartClick);
    
    // Agregar listener usando event delegation
    document.addEventListener('click', handleCartClick);
    
    function handleCartClick(event) {
      // Verificar si el click fue en el cart-icon-bubble o sus hijos
      if (event.target.id === 'cart-icon-bubble' || 
          event.target.closest('#cart-icon-bubble')) {
        console.log("Cart icon clicked via delegation!"); // Debug
        updateAllCart();
        getAllRecomendations();
        open();
      }
    }
    
    console.log("Event delegation para cart-icon-bubble configurado");
  }
  
  // Función de debug para verificar el elemento
  function debugCartIcon() {
    const cartIcon = document.getElementById("cart-icon-bubble");
    console.log("Cart icon element:", cartIcon);
    console.log("Cart icon visible:", cartIcon ? window.getComputedStyle(cartIcon).display !== 'none' : 'Element not found');
    console.log("Cart icon clickable:", cartIcon ? !cartIcon.hasAttribute('disabled') : 'Element not found');
    
    if (cartIcon) {
      console.log("Cart icon classes:", cartIcon.classList.toString());
      console.log("Cart icon styles:", window.getComputedStyle(cartIcon));
    }

    
  }

  document.getElementById("close-cart").addEventListener("click", function () {
    close();
  });

  
   

  try {
    Array.from(
      document.getElementsByClassName("open-when-add-quickview")
    ).forEach((button) => {
      button.addEventListener("click", function () {
        open();
        setTimeout(() => {
          updateAllCart();
          getAllRecomendations();
        }, "1000");
      });
    });
  } catch (error) {
    console.log(error);
  }

  initializeCartListenerWithObserver();

  setTimeout(() => {
    debugCartIcon();
  }, 2000);
  
});